//@ts-check
import React, { useContext } from "react"
import { Navbar, Nav, NavItem } from "react-bootstrap"
import { Context } from "@components/ui-builder/admin-context"
import { useUser } from "@store/profile";
import TeaserStatisticsContext from "@components/TeaserStatistics/TeaserStatisticsContext"

export const FeedAdminToolbar = ({
  disableEdit = false,
  disableStats = false,
  edit = false,
  stats = false,
  handleStatsChange,
}) => (
  <Navbar>
    <Nav>
      {!disableEdit && (
        <NavItem className={edit ? "active" : ""} href={edit ? "?" : "?edit"}>
          Edit Modus
        </NavItem>
      )}
      {!disableStats && (
        <NavItem
          className={stats ? "active" : ""}
          onClick={() => handleStatsChange(!stats)}
        >
          Statistiken
        </NavItem>
      )}
    </Nav>
  </Navbar>
)

export const ConnectedFeedAdminToolbar = () => {
  const isEdit = useContext(Context)
  const { statsVisible, showStats } = useContext(TeaserStatisticsContext)
  const user = useUser()

  return user.admin ? (
    <FeedAdminToolbar
      edit={isEdit}
      stats={statsVisible}
      handleStatsChange={showStats}
    />
  ) : null
}
